// @ts-ignore
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
export const ComponentTableFragmentDoc = gql`
    fragment componentTable on ComponentTable {
  table {
    header {
      cells
    }
    body {
      rows {
        cells
      }
    }
  }
}
    `;